export class CriterionSelectorDialogViewModel
{
    opened: boolean = false;
    selectedCriterionId: number | null = null;
    criteria: { Id: number, ParentId: number | null, Name: string }[] = null;

    show(selectedCriterionId: number | null, criteria: { Id: number, ParentId: number | null, Name: string }[])
    {
        this.selectedCriterionId = selectedCriterionId ?? criteria.find(c => c.ParentId == null).Id;
        this.criteria = criteria;
        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.selectedCriterionId = null;
    }
}